export default __webpack_public_path__ + "static/media/la_capelle2.0ba8acac.jpg";